module.exports = __webpack_public_path__ + "img/hero.a7c3a82d.jpg";;
if (typeof window !== 'undefined') {
(window.__IMAGE_SIZES__ || (window.__IMAGE_SIZES__ = {}))[module.exports] = {"width":486,"height":273,"variants":[]};
}